import { render, staticRenderFns } from "./LocatieInformatieContent.vue?vue&type=template&id=2c9c955d&scoped=true"
import script from "./LocatieInformatieContent.vue?vue&type=script&lang=js"
export * from "./LocatieInformatieContent.vue?vue&type=script&lang=js"
import style0 from "./LocatieInformatieContent.vue?vue&type=style&index=0&id=2c9c955d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c955d",
  null
  
)

export default component.exports